<template>
  <div class="landing-wrapper detail-wrapper">
    <div class="stage-floor"></div>

    <v-container class="landing-main detail-main px-4 px-sm-6 px-md-10 py-8 py-md-12" fluid>
      <div class="detail-wrap" v-if="show">
        <div class="detail-genre" v-if="show.genre">{{ show.genre }}</div>
        <section class="show-detail">
          <v-row class="ma-0 align-center" no-gutters>
            <v-col cols="12" md="7" class="show-detail-left">
              <h2 class="show-detail-title">{{ show.title }}</h2>
              <p class="show-detail-text">{{ show.synopsis }}</p>

              <div class="show-detail-facts">
                <div class="fact-row" v-for="fact in show.facts" :key="fact.label">
                  <span class="fact-label">{{ fact.label }}</span>
                  <span class="fact-value">{{ fact.value }}</span>
                </div>
                <div class="fact-row fact-price" v-if="show.price">
                  <span class="fact-label">VALOR FUNCIÓN</span>
                  <span class="fact-value">{{ show.price }}</span>
                </div>
              </div>

              <div class="show-detail-actions">
                <v-btn class="video-btn" color="grey-darken-4" rounded="lg" @click="openVideo">
                  VIDEO
                  <span class="play-dot">▶</span>
                </v-btn>
                <v-btn class="reserve-btn" color="red-darken-3" rounded="lg" @click="goReserve">RESERVAR</v-btn>
                <v-btn class="back-link detail-back" variant="text" prepend-icon="mdi-undo" @click="goBack">VOLVER</v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="5" class="show-detail-right mt-6 mt-md-0">
              <img :src="show.image" :alt="show.title" class="show-detail-image" />
            </v-col>
          </v-row>
        </section>
      </div>
    </v-container>

    <transition name="video-fade">
      <div v-if="videoOpen" class="video-overlay" @click.self="closeVideo">
        <div class="video-dialog">
          <button type="button" class="video-close" aria-label="Cerrar" @click="closeVideo">✕</button>
          <div class="video-frame">
            <iframe
              v-if="videoEmbedUrl"
              :src="videoEmbedUrl"
              title="Video de la obra"
              frameborder="0"
              referrerpolicy="strict-origin-when-cross-origin"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <p class="video-caption">{{ show.title }}</p>
        </div>
      </div>
    </transition>

    <teatro-footer />
  </div>
</template>

<script>
import { getShowById, detailContent, defaultVideoUrl } from "./teatroData";
import { fetchPlay } from "@/services/teatroApi";

export default {
  name: "ShowDetail",
  props: {
    // Llega desde la URL /obra/<id>/ vía template_vue de Django.
    obraId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      show: null,
      videoOpen: false,
    };
  },
  async created() {
    try {
      this.show = await fetchPlay(this.obraId);
    } catch (e) {
      console.error("No se pudo cargar la obra desde el backend:", e);
    }
    if (!this.show) {
      // Fallback a los datos locales.
      const local = getShowById(this.obraId);
      this.show = {
        ...local,
        synopsis: detailContent.synopsis,
        facts: detailContent.facts,
      };
    }
  },
  computed: {
    videoEmbedUrl() {
      const raw = (this.show && this.show.videoUrl) || defaultVideoUrl;
      const id = this.getYoutubeId(raw);
      return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : raw;
    },
  },
  methods: {
    getYoutubeId(url) {
      // Acepta watch?v= (con otros parámetros antes), embed/, shorts/, live/,
      // youtu.be/ y youtube-nocookie.com.
      const match = String(url).match(
        /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([\w-]{11})/
      );
      return match ? match[1] : "";
    },
    openVideo() {
      this.videoOpen = true;
    },
    closeVideo() {
      this.videoOpen = false;
    },
    goReserve() {
      window.location.href = `/reservar/${this.show.id}/`;
    },
    goBack() {
      window.location.href = "/";
    },
  },
};
</script>
